/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import { useDispatch } from 'react-redux';
import { setRuleConfig } from "@app/modules/PersonaForm/store/PersonaFormStore";
import { useEffect } from "react";

export default function Returning2() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'Returning2',
				config: {
					ruleType: "returning_visitor",
					args: {
						visit_count: 2
					}
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			returning
			users
			visiting
			your
			website
			for
			the
			second
			time.
		</p>
	</>;
}
